import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutSalesperson } from "./autogen/AutogenLayoutSalesperson";

export class Salesperson extends AutogenLayoutSalesperson {
    override onLoad() {
        this.layoutTableContact.parentRowType = "S";
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "salesperson",
            screenName: this.titleSingular,
            navigateToUrl: `${this.layoutName}?mode=update&key=`
        });
    }
}
